import {Card, DatePicker, Form, Input, Select, Spin} from 'antd';
import React from "react";
import {sanitizeFieldName} from "../../util/methods";
import moment from "moment";

class Create extends React.Component {

  componentDidMount() {
    const {match, fetch} = this.props;
    if (match.params && match.params.id) {
      fetch(match.params.id);
    }
  }


  handleSubmit = (e) => {
    const {match} = this.props;
    e.preventDefault();

    this.props.form.validateFields((err, values) => {
      if (err) {
        return console.log(err);
      }

      if (match.params && match.params.id) {
        this.props.onSubmit(values, match.params.id);
      } else {
        this.props.onSubmit(values);
      }
    });
  };

  render() {
    const {getFieldDecorator} = this.props.form;
    const {data, loading, filters, title, resource, form} = this.props;

    return (
      <Spin spinning={loading}>
        <Card className={`gx-card-metrics`} title={`${title} ${sanitizeFieldName(resource)}`}>
          <Form onSubmit={this.handleSubmit} layout="vertical">

            <Form.Item key={'name'} label={'Module Name'}>
              {getFieldDecorator('name', {
                rules: [{required: true, message: `Name is required!`}],
                initialValue: data && data.name,
              })(<Input disabled/>)
              }
            </Form.Item>

            <Form.Item key={'type'} label={'Type'}>
              {getFieldDecorator('type', {
                rules: [{required: true, message: `Type is required!`}],
                initialValue: data && data.type,
              })(<Input disabled/>)
              }
            </Form.Item>

            <Form.Item key={'alteredId'} label={'Altered Id'}>
              {getFieldDecorator('alteredId', {
                rules: [{required: true, message: `Altered Id is required!`}],
                initialValue: data && data.alteredId,
              })(<Input disabled/>)
              }
            </Form.Item>

            <Form.Item key={'user'} label={'User'}>
              {getFieldDecorator('user', {
                rules: [{required: true, message: `User is required!`}],
                initialValue: data && data.user && data.user._id,
              })(<Select
                showSearch
                style={{width: '100%'}}
                placeholder="Please select"
                filterOption={(input, option) =>
                  (option.props.children + "").toLowerCase().indexOf((input+"").toLowerCase()) >= 0
                }
                disabled
              >
                {filters['user'] && filters['user']['data'] && filters['user']['data']['data'].map(item =>
                  <Select.Option key={item._id} value={item._id}>{item.name}</Select.Option>)}
              </Select>)}
            </Form.Item>

            <Form.Item key={'createdAt'} label={'Created Date'}>
              {getFieldDecorator('createdAt', {
                rules: [{required: true, message: `Created Date is required!`}],
                initialValue: data && data.createdAt && moment(data.createdAt),
              })(<DatePicker showTime disabled/>)
              }
            </Form.Item>

            {/*<Form.Item>*/}
            {/*  <Button type="primary" className="gx-mb-0" htmlType="submit" loading={loading}>*/}
            {/*    {this.props.title === 'EDIT' ? 'UPDATE' : 'CREATE'}*/}
            {/*  </Button>*/}
            {/*</Form.Item>*/}
          </Form>
        </Card>
      </Spin>
    );
  }
}

const CreateForm = Form.create({
  name: 'global_state',
  onFieldsChange(props, changedFields) {
    props.onChange(changedFields);
  },
})(Create);

export default CreateForm;
